export default __webpack_public_path__ + "static/media/Roboto-Bold.de0cae95.woff";